import { ProcessField } from '../data/process-field';

export class BodyProcessField {
  fieldId: string | undefined;
  content: string;

  constructor(processField: ProcessField) {
    this.fieldId = processField.formField?.id;
    if (processField.content && typeof processField.content === 'object' && !(processField.content instanceof String)) {
      if (Array.isArray(processField.content)) {
        if (Array.isArray(processField.content[0])) {
          this.content = JSON.stringify(processField.content.filter(s => s.filter((t: []) => t).length));
        } else {
          this.content = JSON.stringify(processField.content.filter(s => s));
        }
      } else {
        this.content = JSON.stringify(processField.content);
      }
    } else {
      this.content = typeof processField.content === 'number' ? String(processField.content) : (processField.content ?? '');
    }
  }
}
